<template>
  <div class="popup">
    <h1 class="page-title text-center mb-5 mb-sm-8">Удаление организации</h1>
    <div class="text-center mb-5 mb-sm-7 sms-confirmation-text">
      Необходимо потвердить удаление организации
    </div>
    <div class="text-center">
      <v-btn class="button popup-button mr-sm-5" color="green" @click="remove">Удалить</v-btn>
      <v-btn class="button popup-button mt-sm-0 mt-5" color="green" @click="onClose">Отметить</v-btn>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import BackButton from '@/components/BackButton.vue';


  export default Vue.extend({
    name: 'UserDeletePopup',
    components: {
      BackButton,
    },
    props: ['userID'],
    data() {
      return {};
    },
    methods: {
      onClose() {
        this.$emit('close');
      },
      remove() {
        this.$emit('remove');
      },
    },

  });
</script>

<style scoped lang="scss" src="@/styles/service/popup.scss">
</style>
